export default ({
  modelValue = null,  // Changed from initialValue to modelValue to match Alpine's conventions
  choices = [],
  htmlName = '',
  label = ''
}) => ({
  // Props
  modelValue,
  label,
  choices,
  htmlName,

  // State
  init() {
    this.selected = this.modelValue;  // Initialize selected in init()
    this.query = '';
  },

  selected: null,  // Declare selected before using it
  query: '',

  // Computed
  get filteredOptions() {
    return this.query === ''
      ? this.choices
      : this.choices.filter((option) => {
          return option.label.toLowerCase().includes(this.query.toLowerCase())
        })
  },

  // Methods
  handleQueryChange(event) {
    this.query = event.target.value;
  },
});
